import webApi from 'Lib/WebApi';
import { callApi } from 'Data/Helpers/rxjsHelpers';
import { Guid } from 'Lib/Guid';
import { map } from 'rxjs/operators';
import { IAgsExport } from 'Data/ViewModels/Ags/IAgsExport';
import { IQApiResponse } from 'Data/ViewModels/Core/IQApiResponse';
import { IAgsExportRevision } from 'Data/ViewModels/Ags';

export const callApiGetAgsExport = (agsExportId: Guid) => {
  return callApi(webApi.ags.exports.get({ agsExportId })).pipe(
    map((response: IQApiResponse<IAgsExport>) => response.Body)
  );
};

export const callApiReissueAgsExport = (agsExportId: Guid) => {
  return callApi(webApi.ags.exports.reissue.post({}, { agsExportId })).pipe(
    map((response: IQApiResponse<IAgsExportRevision>) => response.Body)
  );
};
